<h3>Hardcore calculator</h3>
<div class="calculator-inner calc-col1">
    <div class="calc-fields">
        <div class="inline-label-fields">
            <label class="form-label">
                <span>Total SQM <input  type="number" placeholder="" class="form-control" [(ngModel)]="totalSqm" (ngModelChange)="materialCostChange($event)"><br>
                    Compacted depth of sub-base in mm <input [attr.disabled]="defaultMortar ? true : null"  type="number" placeholder="" class="form-control" [(ngModel)]="mortar" (ngModelChange)="materialCostChange($event)"> <br>
                    I dont't know (default at 50mm)<input type="checkbox" placeholder=""  value="1"  [(ngModel)]="defaultMortar" (ngModelChange)="materialCostChange($event)"></span>
            </label>
        </div>
        <div class="mt-3">
          
           <p > In 25KG Bags:<span> {{ this.total25Kgsbags  }}</span></p>
           <p > In 800KG Bags:<span> {{ this.total800Kgsbags }}</span></p>
           <p > In 1000KG Bags:<span> {{ this.total1000Kgsbags }}</span></p>
          
        </div>
      
      
    </div>
</div>